import React from "react";
import {
    FaUsers,
    FaChartPie,
    FaFlag,
    FaVideo,
    FaPlayCircle,
    FaCoins,
    FaSignOutAlt,
    FaBullhorn
} from "react-icons/fa";

import {
    NavLink,
    useNavigate
} from "react-router-dom";

const AdminNavbar = () => {

    const navigate = useNavigate();

    const logout = () => {

        localStorage.removeItem(
            "authToken"
        );

        localStorage.removeItem(
            "currentUser"
        );

        navigate("/login");
    };


    const linkStyle = ({
        isActive
    }) => ({
        display: "flex",
        alignItems: "center",
        gap: "9px",
        textDecoration: "none",
        padding: "10px 15px",
        borderRadius: "10px",
        fontWeight: "700",
        fontSize: "14px",
        color:
            isActive
                ? "#fff"
                : "#475569",
        background:
            isActive
                ? "#ff5f91"
                : "transparent"
    });


    return (
        <header
            style={{
                position: "sticky",
                top: 0,
                zIndex: 5000,
                background: "#fff",
                borderBottom:
                    "1px solid #e5e7eb"
            }}
        >

            <div
                style={{
                    maxWidth: "1400px",
                    margin: "0 auto",
                    minHeight: "70px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent:
                        "space-between",
                    gap: "25px",
                    padding:
                        "0 24px"
                }}
            >

                <div
                    style={{
                        fontWeight: "900",
                        fontSize: "20px",
                        whiteSpace: "nowrap"
                    }}
                >
                    MyHalal
                    <span
                        style={{
                            color: "#ff5f91",
                            marginLeft: "6px"
                        }}
                    >
                        Admin
                    </span>
                </div>


                <nav
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        overflowX: "auto"
                    }}
                >

                    <NavLink
                        to="/admin"
                        end
                        style={linkStyle}
                    >
                        <FaChartPie />
                        Dashboard
                    </NavLink>

                    <NavLink
                        to="/admin/users"
                        style={linkStyle}
                    >
                        <FaUsers />
                        Users
                    </NavLink>

                    <NavLink
                        to="/admin/reports"
                        style={linkStyle}
                    >
                        <FaFlag />
                        Reports
                    </NavLink>

                    <NavLink
                        to="/admin/live"
                        style={linkStyle}
                    >
                        <FaVideo />
                        Live
                    </NavLink>

                    <NavLink
                        to="/admin/moments"
                        style={linkStyle}
                    >
                        <FaPlayCircle />
                        Moments
                    </NavLink>

                    <NavLink
                        to="/admin/coins"
                        style={linkStyle}
                    >
                        <FaCoins />
                        Coins
                    </NavLink>

                    <NavLink
                        to="/admin/announcements"
                        style={linkStyle}
                    >
                        <FaBullhorn />
                        Announcements
                    </NavLink>

                </nav>


                <button
                    type="button"
                    onClick={logout}
                    style={{
                        border: "none",
                        background: "#f1f5f9",
                        color: "#334155",
                        padding: "10px 15px",
                        borderRadius: "10px",
                        cursor: "pointer",
                        fontWeight: "700",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px"
                    }}
                >
                    <FaSignOutAlt />
                    Logout
                </button>

            </div>

        </header>
    );
};

export default AdminNavbar;